import axios from "axios";

export default {
  getAssociation(token, association, id) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url =
      "/" +
      process.env.CHAPTER_NUMBER +
      "/associations/" +
      association +
      "?id=" +
      id;
    return axios
      .get(url, axiosConfig)
      .then(res => {
        return res.data;
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  postAssociation(token, association, bookNum, info) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url =
      "/" +
      process.env.CHAPTER_NUMBER +
      "/associations/" +
      association +
      "/" +
      bookNum;
    return axios
      .post(url, info, axiosConfig)
      .then(res => {
        return res.data;
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  putAssociation(token, association, id, info) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url =
      "/" +
      process.env.CHAPTER_NUMBER +
      "/associations/" +
      association +
      "/" +
      id;
    return axios
      .put(url, info, axiosConfig)
      .then(res => {
        return res.data;
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  deleteAssociation(token, association, id) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url =
      "/" +
      process.env.CHAPTER_NUMBER +
      "/associations/" +
      association +
      "/" +
      id;
    return axios
      .delete(url, axiosConfig)
      .then(res => {
        return res.data;
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  }
};



// WEBPACK FOOTER //
// ./src/utils/api/associations.js